import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Users, Award, CheckCircle, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { services } from '../data/mock';

const Services = () => {
  const iconMap = {
    ShoppingCart,
    Users,
    Award
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section - wie Über uns, Maschinen und Kontakt */}
      <section className="py-12 md:py-20 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Mobile Überschrift - über dem Bild */}
          <div className="text-center mb-6 md:hidden">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Unsere Leistungen</h1>
            <p className="text-base text-gray-600">
              Professioneller Verkauf von hochwertigen Baumaschinen
            </p>
          </div>
          
          <div className="relative rounded-2xl overflow-hidden">
            <img
              src="https://customer-assets.emergentagent.com/job_7062bdfd-4f57-4d85-897a-fa745eecbadc/artifacts/07tgrsa8_Unsere%20Leistungen.png"
              alt="Unsere Leistungen - Jannesmann Baumaschinen"
              className="w-full h-[280px] sm:h-[400px] md:h-[860px] object-contain sm:object-cover md:object-cover md:object-bottom"
            />
          </div>
        </div>
      </section>

      {/* Services Detail Section */}
      <section className="py-12 md:py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12 md:space-y-20">
            {services.map((service, index) => {
              const IconComponent = iconMap[service.icon];
              const isEven = index % 2 === 0;

              return (
                <div
                  key={service.id}
                  className={`flex flex-col ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 md:gap-12 items-center`}
                >
                  <div className="w-full lg:flex-1">
                    <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                      <IconComponent className="text-red-600" size={32} />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">{service.title}</h2>
                    <p className="text-base md:text-lg text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                    
                    <div className="space-y-3">
                      {service.features.map((feature, idx) => (
                        <div key={idx} className="flex items-start">
                          <CheckCircle className="text-red-600 mr-3 flex-shrink-0 mt-1" size={20} />
                          <span className="text-gray-700">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="w-full lg:flex-1">
                    <Card className="border-2 border-gray-200 shadow-lg w-full">
                      <CardHeader className="bg-gray-50 p-4 md:p-6">
                        <CardTitle className="text-xl md:text-2xl">Ihr Vorteil</CardTitle>
                      </CardHeader>
                      <CardContent className="p-4 md:p-6 min-h-[160px] md:min-h-0">
                        <ul className="space-y-2 md:space-y-3 text-gray-700 text-sm md:text-base">
                          {service.id === 1 && (
                            <>
                              <li>• Eigentum an hochwertigen Baumaschinen</li>
                              <li>• Keine laufenden Kosten</li>
                              <li>• Langfristige Investition</li>
                              <li>• Volle Kontrolle über Ihre Ausrüstung</li>
                            </>
                          )}
                          {service.id === 2 && (
                            <>
                              <li>• Persönliche Fachberatung</li>
                              <li>• Auf Ihre Bedürfnisse zugeschnitten</li>
                              <li>• Transparente Kommunikation</li>
                              <li>• Langfristige Partnerschaft</li>
                            </>
                          )}
                          {service.id === 3 && (
                            <>
                              <li>• Kompetente Kaufberatung</li>
                              <li>• Professionelle Übergabe</li>
                              <li>• Nachbetreuung nach Kauf</li>
                              <li>• Zuverlässiger Service</li>
                            </>
                          )}
                        </ul>
                      </CardContent>
                    </Card>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="border-0 shadow-xl bg-gradient-to-br from-red-600 to-red-700 text-white">
            <CardContent className="p-12 text-center">
              <h2 className="text-3xl md:text-4xl font-bold mb-6">Individuelle Beratung gewünscht?</h2>
              <p className="text-lg mb-8 max-w-2xl mx-auto opacity-90">
                Wir beraten Sie gerne persönlich und finden die optimale Lösung für Ihr Bauvorhaben.
              </p>
              <Link to="/kontakt">
                <Button size="lg" className="bg-white text-red-600 hover:bg-gray-100">
                  Jetzt Kontakt aufnehmen
                  <ArrowRight className="ml-2" size={20} />
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default Services;